import React, {FC} from "react";
import {searchReturnSalesTransactionsReport} from "../../../serviceBroker/transationReportApiServiceBroker";
import {DailyTransactionTypeEnum, PageEnum, TransactionReportSearchParamsModel} from "../../../models";
import {ReportPage, ReportTransactionSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId} from "../../../utils";

export const ReportReturnSalesTransactions: FC = () => {
    const initialState: TransactionReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        lang: getSystemLanguageId(),
        transactionType:DailyTransactionTypeEnum.SalesRefund};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReturnSalesTransactionsReport}
            searchHeader={getPageNameByPageId(PageEnum.ReportReturnSales)}
            SearchPanel={ReportTransactionSearchPanel}
            formId={PageEnum.ReportReturnSales}
        />
    );
};
